import { Image, ImageProps } from 'expo-image';
import { StyleSheet } from 'react-native';

import { LtoContentUS } from '../lto-content/lto-content-us';

export type TopMarketingImageProps = Omit<ImageProps, 'children' | 'source'>;

export function TopMarketingImage(props: TopMarketingImageProps) {
  return (
    <LtoContentUS
      tripleStack={
        <Image
          source={require('./smokin-bbq-triple-stack.webp')}
          placeholder={{ thumbhash: 'sTgKJwjIpriKhndYl0d594h6jAVWWGAF' }}
          alt="Smokin' BBQ Triple Stack. Available in classic or New! Carolina Gold"
          contentFit="cover"
          {...props}
          style={[styles.marketingImage, props.style]}
        />
      }
      thanksgivingSub={
        <>
          <Image
            source={require('./thanksgiving-turkey-sub-card-logo.webp')}
            placeholder={{ thumbhash: 'EcqGIYwnh5h/d3aHf3f4iFdmfol/Zzg' }}
            contentFit="contain"
            {...props}
            style={styles.thanksgivingLogo}
          />
          <Image
            source={require('./thanksgiving-turkey-sub-2025.webp')}
            placeholder={{ thumbhash: 'onqGBQAljaBItoh5WQHLAaQsBnmAe5aahw' }}
            alt="Thanksgiving Turkey Sub."
            contentFit="cover"
            {...props}
            style={[styles.thanksgivingSubImage]}
          />
        </>
      }
      default={
        <Image
          source={require('./hook-and-ladder.webp')}
          placeholder={{ thumbhash: 'IWqGDQIml4eBioL514eAdgxkF0dyiJH5Nw' }}
          alt="Hook & Ladder"
          contentFit="cover"
          {...props}
          style={[styles.marketingImage, props.style]}
        />
      }
    />
  );
}

const styles = StyleSheet.create({
  marketingImage: {
    aspectRatio: 958 / 966,
    width: '96%',
    height: '96%',
    minHeight: 200,
    alignSelf: 'center',
  },
  thanksgivingSubImage: {
    aspectRatio: 800 / 811,
    alignSelf: 'center',
    width: '96%',
  },
  thanksgivingLogo: {
    alignSelf: 'center',
    width: '90%',
    height: 167,
    position: 'absolute',
    zIndex: 1,
    top: -30,
  },
});
